import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper";

const HeroLanding = () => {
  return (
    <Swiper
      pagination={{ clickable: true }}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false
      }}
      modules={[Pagination, Autoplay]}
      className="
        w-full
        h-[28vh]
        sm:h-[38vh]
        md:h-[55vh]
        lg:h-[75vh]
      "
    >

      <SwiperSlide>
        <div className="relative w-full h-full bg-black overflow-hidden">
          <img
            src="/images/hero/banner1.avif"
            alt="Hero Banner"
            loading="eager"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/10" />
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="relative w-full h-full bg-black overflow-hidden">
          <img
            src="/images/hero/banner2.avif"
            alt="Hero Slide 1"
            loading="lazy"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/10" />
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="relative w-full h-full bg-black overflow-hidden">
          <img
            src="/images/hero/banner3.avif"
            alt="Hero Slide 2"
            loading="lazy"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/10" />
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="relative w-full h-full bg-black overflow-hidden">
          <img
            src="/images/hero/banner4.avif"
            alt="Hero Slide 3"
            loading="lazy"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/10" />
        </div>
      </SwiperSlide>

    </Swiper>
  );
};

export default HeroLanding;